module.exports = __webpack_public_path__ + "img/main.c710ab81.jpg";